
































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BodyMapCanvas from "@/components/perioperatif/BodyMapCanvas.vue";
import { storePersetujuanMarkerSite } from "@/store/modules/PersetujuanMarkerSiteStore";
import PersetujuanMarkerSiteSvc from "@/services/PersetujuanMarkerSite";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";

const KUNCI_IDENTITAS_PASIEN = ["penyetuju_nama", "penyetuju_nik"];

@Component({
  components: { CardModalTtd, BodyMapCanvas },
  inject: {
    isReadOnly: { default: () => () => false },
  },
})
export default class CardPersetujuanMarkerSite extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: "ranap" }) context!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean { return this.isReadOnly(); }

  showForm = false;
  isEditing = false;
  selectedItem: any = null;
  modalTtd = false;
  modalMark = false;
  modalTimeout = false;
  markRole = "";
  markName = "";
  signRole = "";
  saving = false;
  autofilling = false;
  savingTimeout = false;
  deleting = false;
  formValid = false;
  menuTanggal = false;
  menuJam = false;
  panels: number[] = [0, 1, 2, 3, 4];
  crossCheckMismatches: any[] = [];
  crossCheckDebounce: any = null;

  form: any = this.getEmptyForm();
  timeoutForm: any = {
    identitas_sesuai_gelang: true,
    diagnosis_sesuai: true,
    prosedur_sesuai_ic: true,
    tanda_jelas: true,
    tanda_terlihat_after_draping: true,
    catatan: "",
  };

  tableHeaders = [
    { text: "Nomor", value: "nomor", width: "160" },
    { text: "Prosedur", value: "prosedur" },
    { text: "Sisi", value: "sisi", width: "100" },
    { text: "Tanggal", value: "tgl_tanda_tangan", width: "120" },
    { text: "Keputusan", value: "keputusan", width: "120" },
    { text: "Status TTD", value: "status_ttd", width: "120" },
  ];

  mounted() {
    storePersetujuanMarkerSite.getByRegister(this.register);
    storePersetujuanMarkerSite.loadMasters();
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
  }

  getEmptyForm() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: userModule.user?.unit_id || null,
      context: this.context,
      diagnosis: "",
      icd10: "",
      prosedur: "",
      icd9cm: "",
      jenis_anestesi: null,
      klasifikasi_operasi: null,
      kelas_perawatan: null,
      sisi: "",
      level_segmen: "",
      gigi_fdi: [],
      perlu_penandaan: true,
      pengecualian_kategori: null,
      alasan_tidak_ditandai: "",
      body_map_data: [],
      lokasi_text: "",
      penanda_jenis: null,
      tanda_jenis: "lingkaran",
      tanda_lainnya_text: "",
      operator_yang_menandai_id: null,
      lokasi_penandaan_kontekstual: "holding_area",
      pasien_sadar_konfirmasi: true,
      pasien_sadar_alasan_tidak: "",
      tanda_visible_after_draping: null,
      keputusan: null,
      alasan_penolakan: "",
      edukasi_keluarga_dilakukan: false,
      edukasi_tertulis_diberikan: false,
      dpjp_decision: null,
      dpjp_user_id: null,
      penyetuju_status: "pasien",
      wali_hubungan: "",
      penyetuju_nama: storePasien.identitasPasien?.nama || "",
      penyetuju_nik: "",
      saksi_pasien_nama: "",
      saksi_pasien_nik: "",
      saksi_pasien_hubungan: null,
      saksi_pasien_hp: "",
      saksi_rs_jabatan: null,
      saksi_rs_unit: "",
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: localISODate(),
      jam_tanda_tangan: new Date().toTimeString().substr(0, 5),
    };
  }

  get loading() { return storePersetujuanMarkerSite.loading; }
  get items() { return storePersetujuanMarkerSite.items; }
  get masters() { return storePersetujuanMarkerSite.masters; }
  get stateuser() { return userModule.user; }
  get dokterList() { return storeDokter.listAll; }
  get hasBlockingMismatch() {
    return this.crossCheckMismatches.some((m: any) => m.severity === "block");
  }
  get operatorInitials() {
    const name = this.stateuser?.nama || "OP";
    return name.split(" ").map((s: string) => s.charAt(0).toUpperCase()).slice(0, 3).join("");
  }

  selectItem(item: any) {
    this.selectedItem = item;
  }

  openCreateForm() {
    this.form = this.getEmptyForm();
    this.showForm = true;
    this.crossCheckMismatches = [];
    this.loadAutofill(true);
  }

  startEdit() {
    const c = this.selectedItem;
    this.form = {
      ...this.getEmptyForm(),
      ...c,
      register_id: this.register,
      pasien_rm: this.rm,
      dpjp_user_id: c.dpjp?.id || null,
      operator_yang_menandai_id: c.operator_yang_menandai?.id || null,
      body_map_data: c.body_map_data || [],
    };
    this.isEditing = true;
  }

  cancelForm() {
    this.showForm = false;
    this.isEditing = false;
    this.form = this.getEmptyForm();
    this.crossCheckMismatches = [];
  }

  async loadAutofill(senyap = false) {
    this.autofilling = true;
    try {
      const resp = await PersetujuanMarkerSiteSvc.autofillFromApb(this.register);
      const d = resp.data.data;
      if (!d) {
        if (!senyap) {
          appModule.NoticeDelay("Tidak ada data yang bisa ditarik untuk register ini");
        }
        return;
      }
      let terisi = 0;
      Object.keys(d).forEach((k: string) => {
        if (KUNCI_IDENTITAS_PASIEN.includes(k) && this.form.penyetuju_status !== "pasien") return;
        if (d[k] === null || d[k] === undefined || d[k] === "") return;
        this.form[k] = d[k];
        terisi++;
      });
      if (!terisi) {
        if (!senyap) {
          appModule.NoticeDelay("Tidak ada data yang bisa ditarik untuk register ini");
        }
        return;
      }
      const sumber = (resp.data.sumber || []).join(", ");
      appModule.NoticeDelay(
        `${terisi} isian terisi otomatis${sumber ? " dari " + sumber : ""} — periksa kembali sebelum menyimpan.`
      );
    } catch {
      // silent
    } finally {
      this.autofilling = false;
    }
  }

  triggerCrossCheck() {
    if (this.crossCheckDebounce) clearTimeout(this.crossCheckDebounce);
    this.crossCheckDebounce = setTimeout(async () => {
      if (!this.form.sisi && !this.form.prosedur && !this.form.icd9cm) {
        this.crossCheckMismatches = [];
        return;
      }
      try {
        const resp = await PersetujuanMarkerSiteSvc.crossCheck(this.register, {
          sisi: this.form.sisi,
          prosedur: this.form.prosedur,
          icd9cm: this.form.icd9cm,
        });
        this.crossCheckMismatches = resp.data.data.mismatches || [];
      } catch {
        this.crossCheckMismatches = [];
      }
    }, 600);
  }

  async simpan() {
    this.saving = true;
    try {
      const payload = { ...this.form };
      // Snapshot body-map PNG
      const bm = this.$refs.bodyMap as any;
      if (bm && payload.perlu_penandaan) {
        try {
          const png = await bm.snapshotPng();
          if (png) payload.body_map_png = png;
        } catch {
          // ignore snapshot failures
        }
      }
      let resp;
      if (this.isEditing && this.selectedItem) {
        resp = await PersetujuanMarkerSiteSvc.update(this.selectedItem.id, payload);
      } else {
        resp = await PersetujuanMarkerSiteSvc.create(payload);
      }
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Persetujuan Marker Site berhasil disimpan");
        this.showForm = false;
        this.isEditing = false;
        this.selectedItem = null;
        this.form = this.getEmptyForm();
        storePersetujuanMarkerSite.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  // Permissions
  get canEdit() {
    if (this.readOnly) return false;
    return this.selectedItem && !this.selectedItem.is_locked;
  }
  get canDelete() {
    if (this.readOnly || !this.selectedItem) return false;
    return !alasanTtdMengunciHapus(
      this.selectedItem.creator_user_id,
      [
        ...slotTandaTanganDokumen(this.selectedItem.signed_dpjp, this.selectedItem.signature_dpjp),
        { ditandatangani: this.selectedItem.signed_penyetuju, penandaTanganId: null },
        { ditandatangani: this.selectedItem.signed_saksi_pasien, penandaTanganId: null },
        ...slotTandaTanganDokumen(this.selectedItem.signed_saksi_rs, this.selectedItem.signature_saksi_rs)
      ],
      this.stateuser?.id
    );
  }
  get canSignDpjp() {
    if (this.readOnly || !this.selectedItem) return false;
    if (this.selectedItem.signed_dpjp) return false;
    return this.selectedItem.dpjp?.id == this.stateuser?.id;
  }
  get canSignSaksiRs() {
    if (this.readOnly || !this.selectedItem) return false;
    if (this.selectedItem.signed_saksi_rs) return false;
    if (this.selectedItem.dpjp?.id == this.stateuser?.id) return false;
    if (this.selectedItem.saksi_rs && this.selectedItem.saksi_rs.id != this.stateuser?.id) return false;
    return true;
  }
  get canMarkPenyetuju() {
    return !this.readOnly && this.selectedItem && !this.selectedItem.signed_penyetuju;
  }
  get canMarkSaksiPasien() {
    return !this.readOnly && this.selectedItem && !this.selectedItem.signed_saksi_pasien;
  }

  get markLabel() {
    return ({ penyetuju: "Yang Menyatakan", saksi_pasien: "Saksi Pihak Pasien" } as any)[this.markRole] || "";
  }

  openMarkPenyetuju() {
    this.markRole = "penyetuju";
    this.markName = this.selectedItem?.penyetuju_nama || "";
    this.modalMark = true;
  }
  openMarkSaksiPasien() {
    this.markRole = "saksi_pasien";
    this.markName = this.selectedItem?.saksi_pasien_nama || "";
    this.modalMark = true;
  }

  async submitMark() {
    const fns: Record<string, Function> = {
      penyetuju: (id: number, n: string) => PersetujuanMarkerSiteSvc.markPenyetuju(id, { penyetuju_nama: n }),
      saksi_pasien: (id: number, n: string) => PersetujuanMarkerSiteSvc.markSaksiPasien(id, { saksi_pasien_nama: n }),
    };
    const fn = fns[this.markRole];
    if (!fn) return;
    const resp = await fn(this.selectedItem.id, this.markName);
    if (resp.data.status == "1") {
      this.modalMark = false;
      appModule.NoticeDelay(resp.data.message);
      this.selectedItem = null;
      storePersetujuanMarkerSite.getByRegister(this.register);
    }
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const fns: Record<string, Function> = {
      dpjp: PersetujuanMarkerSiteSvc.signDpjp,
      saksi_rs: PersetujuanMarkerSiteSvc.signSaksiRs,
    };
    const labels: Record<string, string> = {
      dpjp: "DPJP Operator",
      saksi_rs: "Saksi Pihak RS",
    };
    const fn = fns[this.signRole];
    if (!fn) return;
    const resp = await fn(this.selectedItem.id, { password });
    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay(`Berhasil TTD ${labels[this.signRole]}`);
      appModule.addMsgTtd("");
      this.selectedItem = null;
      storePersetujuanMarkerSite.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  async submitTimeout() {
    this.savingTimeout = true;
    try {
      const resp = await PersetujuanMarkerSiteSvc.submitTimeout(this.selectedItem.id, this.timeoutForm);
      if (resp.data.status == "1") {
        appModule.NoticeDelay(resp.data.message);
        this.modalTimeout = false;
        this.selectedItem = null;
        storePersetujuanMarkerSite.getByRegister(this.register);
      }
    } finally {
      this.savingTimeout = false;
    }
  }

  cetakPdf() {
    PersetujuanMarkerSiteSvc.print(this.selectedItem.id);
  }

  async remove() {
    if (!this.canDelete) return;
    if (!confirm("Anda yakin akan menghapus Persetujuan Marker Site ini?")) return;
    this.deleting = true;
    try {
      const resp = await PersetujuanMarkerSiteSvc.destroy(this.selectedItem.id);
      if (resp?.status == 1) {
        appModule.NoticeDelay(resp.message);
        this.selectedItem = null;
        storePersetujuanMarkerSite.getByRegister(this.register);
      }
    } finally {
      this.deleting = false;
    }
  }
}
